module.exports = "/_next/static/images/kiran2-6e7db661248aef39a6f426fe91747b33.png";